import * as authService from '@/services/auth.service'
import { ErrorWrapper } from '@/services/util'

const state = {
    accessToken: undefined,
    isSignOut: undefined,
}

const getters = {
    isAuthorized: state => {
        return !!state.accessToken
    },
}

const mutations = {
    setAccessToken(state, accessToken) {
        state.accessToken = accessToken || undefined
    },

    setSignOut(state, isSignOut) {
        state.isSignOut = !!isSignOut
    },
}

const actions = {
    async setAccess({ commit }, payload) {
        const accessToken = payload?.accessToken

        await localStorage.setItem('accessToken', accessToken)

        commit('setAccessToken', accessToken)
    },

    async restoreAccess({ commit }) {
        const accessToken = await localStorage.getItem('accessToken')

        commit('setAccessToken', accessToken)
    },

    async sendCode({ dispatch }, payload) {
        const phone = payload?.phone

        try {
            await authService.sendCode({
                phone,
            })
        } catch (error) {
            return Promise.reject(new ErrorWrapper(error.response))
        }
    },

    async signIn({ dispatch }, payload) {
        const phone = payload?.phone
        const code = payload?.code

        let response

        try {
            response = await authService.signIn({
                phone,
                code,
            })
        } catch (error) {
            return Promise.reject(new ErrorWrapper(error.response))
        }

        const accessToken = response?.token

        await dispatch('setAccess', {
            accessToken,
        })
    },

    async signOut({ commit }) {
        await localStorage.removeItem('accessToken')

        commit('setAccessToken', undefined)
        commit('setSignOut', true)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
